import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchMetricsData, fetchCompareMetricsData, downloadMetricsData } from '../../State/actions/sessions';

import Box from 'grommet/components/Box';
import Tabs from 'grommet/components/Tabs';
import Tab from 'grommet/components/Tab';
import Heading from 'grommet/components/Heading';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import Layer from 'grommet/components/Layer';
import Table from 'grommet/components/Table';
//import TableHeader from 'grommet/components/TableHeader';
import TableRow from 'grommet/components/TableRow';
import Paragraph from 'grommet/components/Paragraph';
import Spinning from 'grommet/components/icons/Spinning'

let list = [];

class MetricsData extends Component{
  constructor(props){
     super(props);
     this.state = { ActvSolution: '',
                    ActvSolutionObj: '', 
                    SolutionsList: [], 
                    showCompareSoln: false,
                    TCOSelection: '',
                    dataManipulation:{                   
                      Performance:[true,true,true,true,true],  
                      Capacity:[true,true,true,true,true],
                      Density:[true,true,true,true],
                      Cost:[true,true,true,true],
                      Power:[true],                      
                      CapacityDefaults:{ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},
                      DensityDefaults:{ComputePerf:null,StorageThroughput:null,ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},
                      CostDefaults:{CPUPerf:null, RawStoragecapacity:null,ReplicationStoragecapacity:null,ErasureStoragecapacity:null},
                      PowerDefaults:{CPUPerf:null}
                    },
                      dataManipulationExtra:{                   
                      Performance:[true,true,true,true,true],  
                      Capacity:[true,true,true,true,true],
                      Density:[true,true,true,true],
                      Cost:[true,true,true,true],
                      Power:[true],                      
                      CapacityDefaults:{ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},
                      DensityDefaults:{ComputePerf:null,StorageThroughput:null,ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},
                      CostDefaults:{CPUPerf:null, RawStoragecapacity:null,ReplicationStoragecapacity:null,ErasureStoragecapacity:null},
                      PowerDefaults:{CPUPerf:null}
                    }

                  };
     this.onActvSolutionChange = this.onActvSolutionChange.bind(this);
     this.onExport = this.onExport.bind(this);
     this.onTCOChange = this.onTCOChange.bind(this);
     this.manipulateData = this.manipulateData.bind(this);
     this.manipulateDataExtra=this.manipulateDataExtra.bind(this);
  }

  // componentWillMount(){
  // }

  // componentWillReceiveProps(nextProps){

  //   if(this.props.MetricsData !== nextProps.MetricsData){
  //     this.state.ActvSolution = nextProps.MetricsData.Values.Value[0]['@Header'];
  //     this.state.ActvSolutionObj = nextProps.MetricsData.Values.Value[0];
  //     console.log(nextProps.CompareMetricsData);
  //     nextProps.MetricsData.Values.Value.map( (item, index) => {      
  //       if(item['TotalCost']['#text'] !== '' && item['TotalCost']['#text'] !== undefined ){
  //         list.push(item['@Header']);
  //       }      
  //     });
  //     if(nextProps.MetricsData.Values.Value.length > 1){
  //       list.push('Compare Metrics Data');
  //     }        
  //     this.setState ({SolutionsList: list });
  //   }

  // }

  manipulateData(index,component,metrics)
  {
   var data = this.state.dataManipulation;
   var actvSol = this.state.ActvSolutionObj;
   var value;
    switch(component)
    {
      case 'Performance': data.Performance[index] = !data.Performance[index]; 
                          actvSol['Performance']['Item'].map( (item, itemIndex) => {
                            if(itemIndex === index)
                            {
                              switch(metrics)
                              {
                                case 'CPU Performance' : data.Performance[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dStorageSpecINT) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dStorageSpecINT) 
                                                        item['#text'] = value; break;
                                case 'Storage Throughput': data.Performance[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dComputeThroughPut) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dComputeThroughPut)
                                                        item['#text'] = value; break; 
                                case 'Storage Read IOPS': data.Performance[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dComputeReadIOPS) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dComputeReadIOPS) 
                                                        item['#text'] = value; break;  
                                case 'Storage Write IOPS': data.Performance[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dComputeWriteIOPS) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dComputeWriteIOPS) 
                                                        item['#text'] = value; break;                                                        
                               }
                            }
                          });break;
      case 'Capacity': data.Capacity[index] = !data.Capacity[index];  
                          actvSol['Capacity']['Item'].map( (item, itemIndex) => {
                            if(itemIndex === index)
                            {
                              switch(metrics)
                              {
                                case 'Cores' : data.Capacity[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.iStorageCores) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.iStorageCores) 
                                                        item['#text'] = value; break;
                                case 'Memory': data.Capacity[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.iStorageMemory) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.iStorageMemory)
                                                        item['#text'] = value; break; 
                                case 'Raw Disk Capacity': if(data.Capacity[index]) 
                                                            {  
                                                              value = parseFloat(item['#text']) +  parseFloat(this.props.MetricsData.manipulationData.dComputeDiskCapacity.toFixed(2))
                                                            }
                                                            else{
                                                              value= parseFloat(item['#text']) -  parseFloat(this.props.MetricsData.manipulationData.dComputeDiskCapacity.toFixed(2));
                                                            }                                                          
                                                          item['#text'] = value; break;  
                                case 'Replication Disk Capacity': data.Capacity[index] ? value = parseFloat(data.CapacityDefaults.ReplicationDiskCapacity) :
                                                                  value= parseFloat(((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression).toFixed(2));
                                                                  if(data.CapacityDefaults.ReplicationDiskCapacity === null)
                                                                  {
                                                                    data.CapacityDefaults.ReplicationDiskCapacity = item['#text']
                                                                  }
                                                                  item['#text'] = value;                                                                
                                                                  break;  
                                case 'Erasure 6:3 Disk Capacity': data.Capacity[index] ?  value = parseFloat(data.CapacityDefaults.Erasure6DiskCapacity) : 
                                                                  value= parseFloat(((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression).toFixed(2))
                                                                  if(data.CapacityDefaults.Erasure6DiskCapacity === null)
                                                                  {
                                                                    data.CapacityDefaults.Erasure6DiskCapacity = item['#text']
                                                                  }
                                                                  item['#text'] = value; break;                                                                                                                            
                               }
                            }
                          });break;
      case 'Density Metrics': data.Density[index] = !data.Density[index];                          
                              actvSol['DensityMetrics']['Item'].map( (item, itemIndex) => {
                                if(itemIndex === index)
                                {
                                  switch(metrics)
                                  {
                                    case 'Compute Perf' :data.Density[index] ? value = parseFloat(data.DensityDefaults.ComputePerf) :
                                                         value = (parseFloat(this.props.MetricsData.manipulationData.dComputeSpecINT)/  parseFloat(this.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);                                                                  
                                                                      if(data.DensityDefaults.ComputePerf === null)
                                                                      {
                                                                        data.DensityDefaults.ComputePerf = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break; 
                                    case 'Raw Data Capacity':data.Density[index] ? value = parseFloat(data.DensityDefaults.StorageThroughput) :
                                                         value = (parseFloat(this.props.MetricsData.manipulationData.dStorageDiskCapacity).toFixed(2)/  parseFloat(this.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);                                                                  
                                                                      if(data.DensityDefaults.StorageThroughput === null)
                                                                      {
                                                                        data.DensityDefaults.StorageThroughput = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break;
                                    case 'Replication Data Capacity': data.Density[index] ? value = parseFloat(data.DensityDefaults.ReplicationDiskCapacity) :
                                                                      value= parseFloat((((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);
                                                                      if(data.DensityDefaults.ReplicationDiskCapacity === null)
                                                                      {
                                                                        data.DensityDefaults.ReplicationDiskCapacity = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break;  
                                    case 'Erasure 6:3 Data Capacity': data.Density[index] ?  value = parseFloat(data.DensityDefaults.Erasure6DiskCapacity) : 
                                                                      value= parseFloat((((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression)/this.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);
                                                                      if(data.DensityDefaults.Erasure6DiskCapacity === null)
                                                                      {
                                                                        data.DensityDefaults.Erasure6DiskCapacity = item['#text']
                                                                      }
                                                                      item['#text'] = value; break;                                                        
                                  }
                                }
                              });
                              break;
      case 'Cost Metrics': data.Cost[index] = !data.Cost[index];  
                              actvSol['CostMetrics']['Item'].map( (item, itemIndex) => {
                                if(itemIndex === index){
                                  switch(metrics)
                                  {
                                    case 'CPU Perf/Price':data.Cost[index] ? value = parseFloat(data.CostDefaults.CPUPerf) :
                                                          value = parseFloat((this.props.MetricsData.manipulationData.dComputeSpecINT/this.props.MetricsData.manipulationData.dTotalCost)* 1000).toFixed(2);
                                                            if(data.CostDefaults.CPUPerf === null)
                                                                      {
                                                                        data.CostDefaults.CPUPerf = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break; 
                                                          
                                    case 'Raw Storage capacity/Price':data.Cost[index] ? value = parseFloat(data.CostDefaults.RawStoragecapacity) :
                                                                      value = parseFloat((this.props.MetricsData.manipulationData.dStorageDiskCapacity/this.props.MetricsData.manipulationData.dTotalCost)* 1000).toFixed(2);
                                                                      if(data.CostDefaults.RawStoragecapacity === null)
                                                                      {
                                                                        data.CostDefaults.RawStoragecapacity = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break; 
                                    case 'Replication Storage capacity/Price':data.Cost[index] ? value = parseFloat(data.CostDefaults.ReplicationStoragecapacity) : 
                                                                      value =parseFloat((((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.dTotalCost)*1000).toFixed(2);
                                                                      if(data.CostDefaults.ReplicationStoragecapacity === null)
                                                                      {
                                                                        data.CostDefaults.ReplicationStoragecapacity = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break;
                                    case 'Erasure 6:3 Storage capacity/Price':data.Cost[index] ? value = parseFloat(data.CostDefaults.ErasureStoragecapacity) : 
                                                                              value =parseFloat((((this.props.MetricsData.manipulationData.dStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.dTotalCost)*1000).toFixed(2);
                                                                              if(data.CostDefaults.ErasureStoragecapacity === null)
                                                                              {
                                                                                data.CostDefaults.ErasureStoragecapacity = item['#text']
                                                                              }
                                                                              item['#text'] = value;                                                                
                                                                              break;
                                  }
                                } 
                              });
                              break;
      case 'Power Metrics': data.Power[index] = !data.Power[index];  
                             actvSol['PowerMetrics']['Item'].map( (item, itemIndex) => {
                                if(itemIndex === index){
                                  switch(metrics)
                                  {
                                    case 'CPU Perf/Watt': data.Power[index] ? value = parseFloat(data.PowerDefaults.CPUPerf) :
                                                          value = parseFloat((this.props.MetricsData.manipulationData.dComputeSpecINT/this.props.MetricsData.manipulationData.dTotalPower)* 1000).toFixed(2);
                                                            if(data.PowerDefaults.CPUPerf === null)
                                                                      {
                                                                        data.PowerDefaults.CPUPerf = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break; 
                                  }
                                }
                            });
    } 
    this.setState({dataManipulation : data, ActvSolutionObj:actvSol});
  }

  manipulateDataExtra(index,component,metrics)
  {
     var data = this.state.dataManipulationExtra;
     var actvSol = this.state.ActvSolutionObj;
     var value;
    switch(component)
    {
      case 'Performance': data.Performance[index] = !data.Performance[index]; 
                          actvSol['Performance']['Item'].map( (item, itemIndex) => {
                            if(itemIndex === index)
                            {
                              switch(metrics)
                              {
                                case 'CPU Performance' : data.Performance[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dExtraStorageSpecINT) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dExtraStorageSpecINT);
                                                        item['#text'] = value; break;
                                case 'Storage Throughput': data.Performance[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dExtraComputeThroughPut) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dExtraComputeThroughPut)
                                                        item['#text'] = value; break; 
                                case 'Storage Read IOPS': data.Performance[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dExtraComputeReadIOPS) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dExtraComputeReadIOPS) 
                                                        item['#text'] = value; break;  
                                case 'Storage Write IOPS': data.Performance[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.dExtraComputeWriteIOPS) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.dExtraComputeWriteIOPS ) 
                                                        item['#text'] = value; break;                                                        
                               }
                            }
                          });break;
      case 'Capacity': data.Capacity[index] = !data.Capacity[index];  
                          actvSol['Capacity']['Item'].map( (item, itemIndex) => {
                            if(itemIndex === index)
                            {
                              switch(metrics)
                              {
                                case 'Cores' : data.Capacity[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.iExtraStorageCores) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.iExtraStorageCores) 
                                                        item['#text'] = value; break;
                                case 'Memory': data.Capacity[index] ?  value = parseFloat(item['#text']) + parseFloat(this.props.MetricsData.manipulationData.iExtraStorageMemory) : value= parseFloat(item['#text']) - parseFloat(this.props.MetricsData.manipulationData.iExtraStorageMemory)
                                                        item['#text'] = value; break; 
                                case 'Raw Disk Capacity': if(data.Capacity[index]) 
                                                            {  
                                                              value = parseFloat(item['#text']) +  parseFloat(this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity.toFixed(2))
                                                            }
                                                            else{
                                                              value= parseFloat(item['#text']) -  parseFloat(this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity.toFixed(2));
                                                            }                                                          
                                                          item['#text'] = value; break;  
                                case 'Replication Disk Capacity': data.Capacity[index] ? value = parseFloat(data.CapacityDefaults.ReplicationDiskCapacity) :
                                                                  value= parseFloat(((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression).toFixed(2));
                                                                  if(data.CapacityDefaults.ReplicationDiskCapacity === null)
                                                                  {
                                                                    data.CapacityDefaults.ReplicationDiskCapacity = item['#text']
                                                                  }
                                                                  item['#text'] = value;                                                                
                                                                  break;  
                                case 'Erasure 6:3 Disk Capacity': data.Capacity[index] ?  value = parseFloat(data.CapacityDefaults.Erasure6DiskCapacity) : 
                                                                  value= parseFloat(((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression).toFixed(2))
                                                                  if(data.CapacityDefaults.Erasure6DiskCapacity === null)
                                                                  {
                                                                    data.CapacityDefaults.Erasure6DiskCapacity = item['#text']
                                                                  }
                                                                  item['#text'] = value; break;                                                                                                                            
                               }
                            }
                          });break;
      case 'Density Metrics': data.Density[index] = !data.Density[index];                          
                              actvSol['DensityMetrics']['Item'].map( (item, itemIndex) => {
                                if(itemIndex === index)
                                {
                                  switch(metrics)
                                  {
                                    case 'Compute Perf' :data.Density[index] ? value = parseFloat(data.DensityDefaults.ComputePerf) :
                                                         value = (parseFloat(this.props.MetricsData.manipulationData.dExtraComputeSpecINT - this.props.MetricsData.manipulationData.dExtraStorageSpecINT)/  parseFloat(this.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);                                                                  
                                                                      if(data.DensityDefaults.ComputePerf === null)
                                                                      {
                                                                        data.DensityDefaults.ComputePerf = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break; 
                                    case 'Raw Data Capacity':data.Density[index] ? value = parseFloat(data.DensityDefaults.StorageThroughput) :
                                                         value = (parseFloat(this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity).toFixed(2)/  parseFloat(this.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);                                                                  
                                                                      if(data.DensityDefaults.StorageThroughput === null)
                                                                      {
                                                                        data.DensityDefaults.StorageThroughput = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break;
                                    case 'Replication Data Capacity': data.Density[index] ? value = parseFloat(data.DensityDefaults.ReplicationDiskCapacity) :
                                                                      value= parseFloat((((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);
                                                                      if(data.DensityDefaults.ReplicationDiskCapacity === null)
                                                                      {
                                                                        data.DensityDefaults.ReplicationDiskCapacity = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break;  
                                    case 'Erasure 6:3 Data Capacity': data.Density[index] ?  value = parseFloat(data.DensityDefaults.Erasure6DiskCapacity) : 
                                                                      value= parseFloat((((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression)/this.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);
                                                                      if(data.DensityDefaults.Erasure6DiskCapacity === null)
                                                                      {
                                                                        data.DensityDefaults.Erasure6DiskCapacity = item['#text']
                                                                      }
                                                                      item['#text'] = value; break;                                                        
                                  }
                                }
                              });
                              break;
      case 'Cost Metrics': data.Cost[index] = !data.Cost[index];  
                              actvSol['CostMetrics']['Item'].map( (item, itemIndex) => {
                                if(itemIndex === index){
                                  switch(metrics)
                                  {
                                    case 'CPU Perf/Price':data.Cost[index] ? value = parseFloat(data.CostDefaults.CPUPerf) :
                                                          value = parseFloat(((this.props.MetricsData.manipulationData.dExtraComputeSpecINT - this.props.MetricsData.manipulationData.dExtraStorageSpecINT)/this.props.MetricsData.manipulationData.dExtraTotalCost)* 1000).toFixed(2);
                                                            if(data.CostDefaults.CPUPerf === null)
                                                                      {
                                                                        data.CostDefaults.CPUPerf = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break; 
                                                          
                                    case 'Raw Storage capacity/Price':data.Cost[index] ? value = parseFloat(data.CostDefaults.RawStoragecapacity) :
                                                                      value = parseFloat((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/this.props.MetricsData.manipulationData.dExtraTotalCost)* 1000).toFixed(2);
                                                                      if(data.CostDefaults.RawStoragecapacity === null)
                                                                      {
                                                                        data.CostDefaults.RawStoragecapacity = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break; 
                                    case 'Replication Storage capacity/Price':data.Cost[index] ? value = parseFloat(data.CostDefaults.ReplicationStoragecapacity) : 
                                                                      value =parseFloat((((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / this.props.MetricsData.manipulationData.dReplication * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.dExtraTotalCost)*1000).toFixed(2);
                                                                      if(data.CostDefaults.ReplicationStoragecapacity === null)
                                                                      {
                                                                        data.CostDefaults.ReplicationStoragecapacity = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break;
                                    case 'Erasure 6:3 Storage capacity/Price':data.Cost[index] ? value = parseFloat(data.CostDefaults.ErasureStoragecapacity) : 
                                                                              value =parseFloat((((this.props.MetricsData.manipulationData.dExtraStorageDiskCapacity) / 1.5 * (1 - this.props.MetricsData.manipulationData.dOverhead) * this.props.MetricsData.manipulationData.dCompression) / this.props.MetricsData.manipulationData.dExtraTotalCost)*1000).toFixed(2);
                                                                              if(data.CostDefaults.ErasureStoragecapacity === null)
                                                                              {
                                                                                data.CostDefaults.ErasureStoragecapacity = item['#text']
                                                                              }
                                                                              item['#text'] = value;                                                                
                                                                              break;
                                  }
                                } 
                              });
                              break;
      case 'Power Metrics': data.Power[index] = !data.Power[index];  
                             actvSol['PowerMetrics']['Item'].map( (item, itemIndex) => {
                                if(itemIndex === index){
                                  switch(metrics)
                                  {
                                    case 'CPU Perf/Watt': data.Power[index] ? value = parseFloat(data.PowerDefaults.CPUPerf) :
                                                          value = Math.round(parseFloat(((this.props.MetricsData.manipulationData.dExtraComputeSpecINT - this.props.MetricsData.manipulationData.dExtraStorageSpecINT)/this.props.MetricsData.manipulationData.dTotalExtraPower)* 1000));
                                                            if(data.PowerDefaults.CPUPerf === null)
                                                                      {
                                                                        data.PowerDefaults.CPUPerf = item['#text']
                                                                      }
                                                                      item['#text'] = value;                                                                
                                                                      break; 
                                  }
                                }
                            });
    }
    this.setState({dataManipulation : data, ActvSolutionObj:actvSol});
  }

  componentWillMount(){
    this.props.onFetchMetricsData({'SessionID': this.props.activeSession.id});
    this.props.onFetchCompareMetricsData({'SessionID': this.props.activeSession.id});
  }

  // componentDidMount(){
  //   this.props.onFetchCompareMetricsData({'SessionID': this.props.activeSession.id});
  // }

  componentWillReceiveProps(nextProps){
    list = [];
    
    if(this.props.MetricsData !== nextProps.MetricsData){
        

        nextProps.MetricsData.output.Values.Value.map( (item, index) => {      
          if(item['TotalCost']['#text'] !== '' && item['TotalCost']['#text'] !== undefined ){
            list.push(item['@Header']);
            if(list.length==1)
            {
              this.state.ActvSolution = item['@Header'];
              this.state.ActvSolutionObj = nextProps.MetricsData.output.Values.Value[index];   
            }
          }      
        });
        
        

        if(list.indexOf('Elastic Config') !== -1  && list.indexOf('Traditional Nodes') !== -1)
        {
          list.push('Compare Metrics Data');
        }
               
        this.setState({SolutionsList: list});
    }
  }

  onActvSolutionChange(e){
    if(e.value === 'Compare Metrics Data'){
      this.setState({ ActvSolution: e.value, showCompareSoln: true });
    }else{
      this.props.MetricsData.output.Values.Value.map( (item, index) => {
        if(item['@Header'] === e.value ){
          this.state.ActvSolutionObj = item;
        }
      });
      this.setState({ ActvSolution: e.value, showCompareSoln: false });
    }
  }

  onExport(){
   
   var data;
   if(this.state.ActvSolution === 'Compare Metrics Data')
   {
    
    var obj={
      root:{
        element:JSON.parse(JSON.stringify(this.props.CompareMetricsData)),
        additionalInfo:{
          isCompareSolution:true
          } 
      }
    }
    // var root = {
    //   root :obj
    // }
    data = {
      "Data": obj
    };  
   }
   else{
     var filter = JSON.parse(JSON.stringify(this.props.MetricsData.output));   
     var temp;
    if(Array.isArray(filter.Values.Value))
    {
      filter.Values.Value.forEach((item)=>{
        if(item['@Header'] === this.state.ActvSolution)
        {
            temp = item;
        }
      });
      if(temp!== undefined){
      filter.Values.Value = [];
      filter.Values.Value.push(temp);
      }
      var content={
        root:{
        filter:filter,
          additionalInfo:{
            FactoryExpress:this.props.FactoryExpressdata.workload.UserInputs.Environments.FactoryExpress,
            isCompareSolution:false
          }
        }
      }
    }      
    data = {
      "Data": content
    };
   }
    this.props.onExportMetricsData(data);
  }

  onTCOChange(e){
      var val = '';
      this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map( (item, index) => {
        if(item['@Text'] === e.value)
                val = item['#text'];
      });
      this.setState({ TCOValue: val, TCOSelection: e.value });
  }
  
  render(){
    
    let MainData = '';
    let tblRowStyle = { border:'1px solid #ccc' };
    let tblRowBoldStyle = { border:'1px solid #ccc', fontWeight: 'bold' };
    let tbltdStyle = { padding: '5px',textAlign: 'left', width: '10px !important' };
    let tbltdStyle_btn = { padding: '0px',textAlign: 'left', borderColor:'white' };
    let btnStyle = { padding: '0px',textAlign: 'left', background: 'rgb(255, 141, 109)',border: '1px solid', color: 'white',marginLeft: '5px' };
    let tbltdBoldStyle = { padding: '5px',textAlign: 'left', width: '80px !important', fontWeight: 'bold' };

    let totalcostItems = '';
    let mainTotalCost = '';
    let TCOList = [];
    let TCOItems = '';
    let FactoryExpress = '';
    let FactoryExpressPerc = '';

    let perfItems = '';
    let capacityItems = '';
    let densityItems = '';
    let costItems = '';
    let powerItems = '';

    // Compare Metrics Variables
    let compareMetricsItems = '';

    let LoadingLayer = '';
    if(this.props.isLoading){
      LoadingLayer = <Layer style={{zIndex:'500 !important'}}>
                <Box direction='row' style={{padding: '40px'}} size='medium' pad={{'between':'small'}}>
                     <Spinning size='small'/>
                     <Heading tag='h5' margin='none'>{this.props.LoadingMsg}</Heading>
                </Box>
              </Layer>
    }

    if(this.state.ActvSolutionObj !== ''){

      totalcostItems = this.state.ActvSolutionObj['TotalCostMetrics']['Item'].map( (item, index) => {
                            return <TableRow key={index} style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                  </TableRow>
      });

      mainTotalCost = <TableRow style={tblRowBoldStyle} >
                         <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCost']['@Text']}</td>
                         <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']}</td>
                         <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCost']['#text']}</td>
                      </TableRow>  
      
      if(this.state.TCOSelection === ''){ 
         this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map( (item, index) => {
            TCOList.push(item['@Text']); 
         });
         this.state.TCOSelection = TCOList[0];
         this.state.TCOValue = this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'][0]['#text'];
       }else{
         this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map( (item, index) => {
            TCOList.push(item['@Text']); 
         });
      }

      var FEOptCost = '';
      var FEOptPerc = '';
      this.state.ActvSolutionObj['ComboOptions']['FEOptionsCost']['Item'].filter( (item, index) => {
           if(item['@Text'] === this.props.FactoryExpressdata.workload.UserInputs.Environments.FactoryExpress){ 
             FEOptCost = item['#text']; 
           }
      });
      this.state.ActvSolutionObj['ComboOptions']['FEOptionsPerc']['Item'].filter( (item, index) => {
           if(item['@Text'] === this.props.FactoryExpressdata.workload.UserInputs.Environments.FactoryExpress){
             FEOptPerc = item['#text']; 
           }
      })
      
      FactoryExpress = <TableRow style={tblRowBoldStyle} >
                         <td style={tbltdStyle} >{this.props.FactoryExpressdata.workload.UserInputs.Environments.FactoryExpress}</td>
                      {/*   <td style={tbltdStyle} >{this.state.ActvSolutionObj['ComboOptions']['FEOptionsCost']['@Unit']}</td>*/}
                        <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']}</td>
                         <td style={tbltdStyle} >{FEOptCost}</td>
                      </TableRow>

      FactoryExpressPerc = <TableRow style={tblRowBoldStyle} >
                         <td style={tbltdStyle} >{this.props.FactoryExpressdata.workload.UserInputs.Environments.FactoryExpress}</td>
                          <td style={tbltdStyle} >{this.state.ActvSolutionObj['ComboOptions']['FEOptionsPerc']['@Unit']}</td>
                          {/* <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']}</td>*/}
                         <td style={tbltdStyle} >{FEOptPerc}</td>
                      </TableRow>

      TCOItems = <TableRow style={tblRowBoldStyle} >
                         <td style={tbltdStyle} > <Select options={TCOList} 
                                                          onChange={ this.onTCOChange }
                                                          value={this.state.TCOSelection} /> </td>
                         {/* <td style={tbltdStyle} >{this.state.ActvSolutionObj['ComboOptions']['TCO']['@Unit']}</td>*/}
                         <td style={tbltdStyle} >{this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']}</td>
                         <td style={tbltdStyle} >{this.state.TCOValue}</td>
                      </TableRow>

      if(this.props.CompareMetricsData !== ''){
            compareMetricsItems = this.props.CompareMetricsData.map( (metItem, index) => {
                          if((metItem['Unit'] === null && metItem['Metrics'] !== ' ') ||(metItem['Unit'] === " " && metItem['Metrics'] !== ' ')){
                              return <TableRow key={index} style={tblRowBoldStyle} rowSpan='4' >
                                        <th style={tbltdBoldStyle} >{metItem['Metrics']}</th>
                                     </TableRow>
                          }else if(metItem['Metrics'] !== ' ' && metItem['Unit'] !== null ){
                              return <TableRow key={index} style={tblRowStyle} >
                                        <td style={tbltdStyle} >{metItem['Metrics']}</td>
                                        <td style={tbltdStyle} >{metItem['Unit']}</td>
                                        <td style={tbltdStyle} >{metItem['WDO_Config']}</td>
                                        <td style={tbltdStyle} >{metItem['Traditional_Nodes']}</td>
                                     </TableRow>
                          }
            });
      }

      switch (this.state.ActvSolutionObj['@Header']) {
       
       case 'Elastic Config':{
            perfItems = this.state.ActvSolutionObj['Performance']['Item'].map( (item, index) => {
                            var text='';
                            this.state.dataManipulation.Performance[index] ?  text='Remove' :   text='Add' ;       
                            item['@Text'].indexOf('Performance') > 0 ? text += ' Storage' : text += ' Compute';                                             
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                         <td style={tbltdStyle_btn}><Button plain={true} style={btnStyle} label={text} onClick={()=>{this.manipulateData(index,'Performance',item['@Text'])}}/></td>  
                                    </TableRow>      
                                    /* Changes by Vinay, removed open and close braces as the content inside that is commented. for CID:10009*/
                                      /*<td style={tbltdStyle} onClick={()=>{this.manipulateData(index,'Performance',item['@Text'])}}>{text}</td>      */
                                 
                        })
            capacityItems = this.state.ActvSolutionObj['Capacity']['Item'].map( (item, index) => {
                            var text='';
                            this.state.dataManipulation.Capacity[index] ?  text='Remove' :   text='Add' ;       
                            item['@Text'].indexOf('Capacity') > 0 ? text += ' Compute' : text += ' Storage';      
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                        <td style={tbltdStyle_btn} ><Button plain={true} style={btnStyle}label={text} onClick={()=>{this.manipulateData(index,'Capacity',item['@Text'])}}/></td>
                                     {/*   <td style={tbltdStyle} onClick={()=>{this.manipulateData(index,'Capacity',item['@Text'])}}>{text}</td>  */}  
                                  </TableRow>
                        }) 
            densityItems = this.state.ActvSolutionObj['DensityMetrics']['Item'].map( (item, index) => {
                            var text='';
                            this.state.dataManipulation.Density[index] ?  text='Remove' :   text='Add' ;       
                            item['@Text'].indexOf('Capacity') > 0 ? text += ' Compute' : text += ' Storage';    

                                return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                        {this.state.dataManipulation.Density[index] !== undefined ? 
                                        <td style={tbltdStyle_btn} ><Button label={text} plain={true} style={btnStyle} onClick={()=>{this.manipulateData(index,'Density Metrics',item['@Text'])}}/></td> :
                                        ''}
                                      {/*  {this.state.dataManipulation.Density[index] !== undefined ? 
                                        <td style={tbltdStyle} onClick={()=>{this.manipulateData(index,'Density Metrics',item['@Text'])}}>{text}</td> :
                                        ''}*/}
                                  </TableRow>

                                  // <TableRow style={tblRowStyle} >
                                  //  <td style={tbltdStyle} onClick={()=>{this.manipulateData(index,'Density Metrics',item['@Text'])}}>{text}</td> 
                                  // </TableRow>
                             //} 
                           
                        })
            costItems = this.state.ActvSolutionObj['CostMetrics']['Item'].map( (item, index) => {
                            var text='';
                            this.state.dataManipulation.Cost[index] ?  text='Remove' :   text='Add' ;       
                            item['@Text'].indexOf('capacity') > 0 ? text += ' Compute' : text += ' Storage';    
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                        {this.state.dataManipulation.Cost[index] !== undefined ? 
                                        <td style={tbltdStyle_btn} ><Button label={text} plain={true} style={btnStyle} onClick={()=>{this.manipulateData(index,'Cost Metrics',item['@Text'])}}/></td> :
                                        ''}
                                      {/*   {this.state.dataManipulation.Cost[index] !== undefined ? 
                                        <td style={tbltdStyle} onClick={()=>{this.manipulateData(index,'Cost Metrics',item['@Text'])}}>{text}</td> :
                                        ''}*/}
                                  </TableRow>
                        })
            powerItems = this.state.ActvSolutionObj['PowerMetrics']['Item'].map( (item, index) => {
                             var text='';
                            this.state.dataManipulation.Power[index] ?  text='Remove' :   text='Add' ;       
                            item['@Text'].indexOf('Capacity') > 0 ? text += ' Compute' : text += ' Storage'; 
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                        {this.state.dataManipulation.Power[index] !== undefined ? 
                                        <td style={tbltdStyle_btn} ><Button label={text} plain={true}  style={btnStyle} onClick={()=>{this.manipulateData(index,'Power Metrics',item['@Text'])}}/></td> :
                                        ''}
                                        {/*  {this.state.dataManipulation.Power[index] !== undefined ? 
                                        <td style={tbltdStyle} onClick={()=>{this.manipulateData(index,'Power Metrics',item['@Text'])}}>{text}</td> :
                                        ''}*/}
                                  </TableRow>
            });
            break;
       }

       case 'Extra Nodes':{
            perfItems = this.state.ActvSolutionObj['Performance']['Item'].map( (item, index) => {
                            var text='';
                            this.state.dataManipulationExtra.Performance[index] ?  text='Remove' :   text='Add' ;       
                            item['@Text'].indexOf('Performance') > 0 ? text += ' Custom' : text += ' Edge';  
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                        <td style={tbltdStyle_btn} ><Button plain={true} style={btnStyle} label={text} onClick={()=>{this.manipulateDataExtra(index,'Performance',item['@Text'])}}/></td>  
                                  </TableRow>
                        }) 
            capacityItems = this.state.ActvSolutionObj['Capacity']['Item'].map( (item, index) => {
                            var text='';
                            this.state.dataManipulationExtra.Capacity[index] ?  text='Remove' :   text='Add' ;       
                            item['@Text'].indexOf('Capacity') > 0 ? text += ' Edge' : text += ' Custom';
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                         <td style={tbltdStyle_btn} ><Button plain={true} style={btnStyle} label={text} onClick={()=>{this.manipulateDataExtra(index,'Capacity',item['@Text'])}}/></td>  
                                  </TableRow>
                        }) 
            densityItems = this.state.ActvSolutionObj['DensityMetrics']['Item'].map( (item, index) => {
              var text='';
                            this.state.dataManipulationExtra.Density[index] ?  text='Remove' :   text='Add' ;       
                            item['@Text'].indexOf('Capacity') > 0 ? text += ' Edge' : text += ' Custom';
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                          {this.state.dataManipulationExtra.Density[index] !== undefined ? 
                                        <td style={tbltdStyle_btn} ><Button label={text} plain={true} style={btnStyle} onClick={()=>{this.manipulateDataExtra(index,'Density Metrics',item['@Text'])}}/></td> :
                                        ''}
                                  </TableRow>
                        })
            costItems = this.state.ActvSolutionObj['CostMetrics']['Item'].map( (item, index) => {
              var text='';
                            this.state.dataManipulationExtra.Cost[index] ?  text='Remove' :   text='Add' ;       
                            item['@Text'].indexOf('capacity') > 0 ? text += ' Edge' : text += ' Custom';
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                         {this.state.dataManipulationExtra.Cost[index] !== undefined ? 
                                        <td style={tbltdStyle_btn} ><Button label={text} plain={true} style={btnStyle} onClick={()=>{this.manipulateDataExtra(index,'Cost Metrics',item['@Text'])}}/></td> :
                                        ''}
                                  </TableRow>
                        })
            powerItems = this.state.ActvSolutionObj['PowerMetrics']['Item'].map( (item, index) => {
               var text='';
                            this.state.dataManipulationExtra.Power[index] ?  text='Remove' :   text='Add' ;       
                            text += ' Custom';
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                        {this.state.dataManipulationExtra.Power[index] !== undefined ? 
                                        <td style={tbltdStyle_btn} ><Button label={text} plain={true}  style={btnStyle} onClick={()=>{this.manipulateDataExtra(index,'Power Metrics',item['@Text'])}}/></td> :
                                        ''}
                                  </TableRow>
            });
            break;
       }
       
       case 'Traditional Nodes':{
            perfItems = this.state.ActvSolutionObj['Performance']['Item'].map( (item, index) => {
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                  </TableRow>
                        })
            capacityItems = this.state.ActvSolutionObj['Capacity']['Item'].map( (item, index) => {
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                  </TableRow>
                        }) 
            densityItems = this.state.ActvSolutionObj['DensityMetrics']['Item'].map( (item, index) => {
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                  </TableRow>
                        })
            costItems = this.state.ActvSolutionObj['CostMetrics']['Item'].map( (item, index) => {
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                  </TableRow>
                        })
            powerItems = this.state.ActvSolutionObj['PowerMetrics']['Item'].map( (item, index) => {
                            return <TableRow style={tblRowStyle} >
                                        <td style={tbltdStyle} >{item['@Text']}</td>
                                        <td style={tbltdStyle} >{item['@Unit']}</td>
                                        <td style={tbltdStyle} >{item['#text']}</td>
                                  </TableRow>
            });
            break;
       }

       default : break;
      }

      if( !this.state.showCompareSoln ){
          MainData =           
                <Tabs justify='start' style={{width:'100%'}}>
                      <Tab title='Total Cost Metrics'>                
                        <Box direction='row' separator='bottom' className="TabInnerSection MetricsTable" margin="none" pad="none" justify='center' align='center' 
                               style={{ height:'500px', width:'100% !important', overflowX: 'hidden', overflowY: 'auto'}}>
                                <Table scrollable={true} style={{marginTop:'470px'}} >                                   
                                  {/*<TableHeader labels={['Metrics', 'Unit', 'Value']} />*/}
                                  <thead><tr><th style={{width:'35%'}}>Metrics</th><th style={{width:'10%'}}>Unit</th><th style={{width:'30%'}}>Value</th><th style={{backgroundColor: 'white',border: 'white'}}></th></tr></thead>
                                  <tbody>
                                    { totalcostItems }
                                    { mainTotalCost }
                                    { FactoryExpress }
                                    { FactoryExpressPerc }
                                    { TCOItems }
                                  </tbody>
                                  
                                </Table>
                          </Box>
                      </Tab> 
                      <Tab title='Performance' >
                          <Box direction='row' className="TabInnerSection MetricsTable_Button" margin="none" pad="none" justify='center' align='center' style={{height:'100%',width:'100%! important'}}>                               
                                <Table>
                                 <thead><tr><th style={{width:'25%'}}>Metrics</th><th style={{width:'10%'}}>Unit</th><th style={{width:'20%'}}>Value</th><th style={{backgroundColor: 'white',border: 'white'}}></th></tr></thead>
                                  <tbody>
                                    { perfItems }
                                  </tbody>
                                </Table>                                                                
                                
                                
                          </Box>
                      </Tab>
                      <Tab title='Capacity' >
                          <Box direction='row' className="TabInnerSection MetricsTable_Button" margin="none" pad="none" justify='center' align='center' style={{height:'100%',width:'100%! important'}}>
                                <Table>
                                  <thead><tr><th style={{width:'25%'}}>Metrics</th><th style={{width:'10%'}}>Unit</th><th style={{width:'20%'}}>Value</th><th style={{backgroundColor: 'white',border: 'white'}}></th></tr></thead>
                                  <tbody>
                                    { capacityItems }
                                  </tbody>
                                </Table>
                          </Box>
                      </Tab> 
                      <Tab title='Density Metrics' >
                          <Box direction='row' className="TabInnerSection MetricsTable_Button" margin="none" pad="none" justify='center' align='center' style={{height:'100%',width:'100%!import'}}>
                                <Table>
                                 <thead><tr><th style={{width:'25%'}}>Metrics</th><th style={{width:'15%'}}>Unit</th><th style={{width:'23%'}}>Value</th><th style={{backgroundColor: 'white',border: 'white'}}></th></tr></thead>
                                  <tbody>
                                    { densityItems }
                                  </tbody>
                                </Table>
                          </Box>
                      </Tab>
                      <Tab title='Cost Metrics' >
                          <Box direction='row' className="TabInnerSection MetricsTable_Button" margin="none" pad="none" justify='center' align='center' style={{height:'100%',width:'100%!import'}}>
                                <Table>
                                  <thead><tr><th style={{width:'30%'}}>Metrics</th><th style={{width:'15%'}}>Unit</th><th style={{width:'20%'}}>Value</th><th style={{backgroundColor: 'white',border: 'white'}}></th></tr></thead>
                                  <tbody>
                                    { costItems }
                                  </tbody>
                                </Table>
                          </Box>
                      </Tab> 
                      <Tab title='Power Metrics' >
                          <Box direction='row' className="TabInnerSection MetricsTable_Button" margin="none" pad="none" justify='center' align='center' style={{height:'100%',width:'100%!import'}}>
                                <Table>
                                  <thead><tr><th style={{width:'25%'}}>Metrics</th><th style={{width:'25%'}}>Unit</th><th style={{width:'20%'}}>Value</th><th style={{backgroundColor: 'white',border: 'white'}}></th></tr></thead>
                                  <tbody>
                                    { powerItems }
                                  </tbody>
                                </Table> 
                          </Box>
                      </Tab>    
                </Tabs>

        }else{
          MainData = <Box separator='bottom' className="TabInnerSection MetricsTable" margin="none" pad="none" justify='center' align='center' 
                          style={{ height:'600px', width:'50% !important', overflowX: 'hidden', overflowY: 'auto' }}>
                                <Table className='marginClassforIe' scrollable={true} style={{marginTop:'50px', height:'100%' }} > 
                                  {/*<TableHeader labels={['Metrics', 'Unit', 'Elastic Config', 'Traditional Nodes']} />*/}
                                  <thead><tr><th>Metrics</th><th>Unit</th><th>Elastic Config</th><th>Traditional Nodes</th></tr></thead>
                                  <tbody>
                                    { compareMetricsItems }
                                  </tbody>
                                </Table>     
                     </Box>
        //   MainData = <Box separator='all' className="TabInnerSection" 
        //                   margin="none" pad="small" justify='start' align='start' 
        //                   style={{ height:'630px', marginTop: '12px', width:'100% !important', overflow:'auto' }} >
                            
          //                   <Table scrollable={true} >
          //                       <TableHeader labels={['Metrics', 'Unit', 'WDO Config']} />
          //                       <tbody>
          //                         <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >CPU Perf/Price</td>
          //                             <td style={tbltdStyle} >SpecINT/$1K</td>
          //                             <td style={tbltdStyle} >16.23</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Raw Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.11</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Replication Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.03</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Erasure 6:3 Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.06</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Storage Perf/Price</td>
          //                             <td style={tbltdStyle} >MB/s per $1K</td>
          //                             <td style={tbltdStyle} >25.21</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >CPU Perf/Price</td>
          //                             <td style={tbltdStyle} >SpecINT/$1K</td>
          //                             <td style={tbltdStyle} >16.23</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Raw Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.11</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Replication Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.03</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Erasure 6:3 Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.06</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Storage Perf/Price</td>
          //                             <td style={tbltdStyle} >MB/s per $1K</td>
          //                             <td style={tbltdStyle} >25.21</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >CPU Perf/Price</td>
          //                             <td style={tbltdStyle} >SpecINT/$1K</td>
          //                             <td style={tbltdStyle} >16.23</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Raw Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.11</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Replication Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.03</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Erasure 6:3 Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.06</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Storage Perf/Price</td>
          //                             <td style={tbltdStyle} >MB/s per $1K</td>
          //                             <td style={tbltdStyle} >25.21</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >CPU Perf/Price</td>
          //                             <td style={tbltdStyle} >SpecINT/$1K</td>
          //                             <td style={tbltdStyle} >16.23</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Raw Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.11</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Replication Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.03</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Erasure 6:3 Storage capacity/Price</td>
          //                             <td style={tbltdStyle} >TB/$1K</td>
          //                             <td style={tbltdStyle} >0.06</td>
          //                           </TableRow>
          //                           <TableRow style={tblRowStyle} >
          //                             <td style={tbltdStyle} >Storage Perf/Price</td>
          //                             <td style={tbltdStyle} >MB/s per $1K</td>
          //                             <td style={tbltdStyle} >25.21</td>
          //                         </TableRow>
          //                       </tbody>
          //                   </Table>

        //              </Box>
      }
    }

    return(
       <Box margin="none" pad="small" style={{width:'100% !important',height:'100%'}}>                    
            <Box direction='row' margin="none" pad={{between: 'small'}} >
                 <Heading tag='h5' margin='small' strong={false} >Solutions : </Heading>
                 <Select onChange={this.onActvSolutionChange.bind(this) } 
                         options={this.state.SolutionsList} style={{maxWidth:'225px'}}
                         value={ this.state.ActvSolution } />
                 <Button label='Export to Excel' primary={true} onClick={this.onExport} style={{height:'40px', marginTop: '3px'}} />
                 {this.state.ActvSolution === 'Compare Metrics Data' ? 
                 <Paragraph style={{margin:'12px 0px 0px 100px', color:'red' }}>Note: Extra node values are included in Elastic config value.</Paragraph>:''}
            </Box> 
            {LoadingLayer}         
            <Box margin="none" pad="none" style={{width:'100% !important'}}>
            {MainData}
            </Box>
            
       </Box>
    );
  }
}

 const mapStateToProps = (state) => {  
  return{
      isLoading: state.sessions.isLoading,
      LoadingMsg: state.sessions.LoadingMsg,
      activeSession: state.sessions.activeSession,
      MetricsData: state.sessions.activeSession.MetricsData,
      CompareMetricsData: state.sessions.activeSession.CompareMetricsData,
      FactoryExpressdata:state.sizerWorkload
  }
 };

  const mapDispatchToProps = (dispatch) => {
    return {      
        onFetchMetricsData: (obj) => {
          dispatch(fetchMetricsData(obj));
        },
        onFetchCompareMetricsData: (obj) => {
          dispatch(fetchCompareMetricsData(obj));
        },
        onExportMetricsData: (data) => {
          dispatch(downloadMetricsData(data));
        }
    };
 };

export default connect(mapStateToProps,mapDispatchToProps)(MetricsData); 



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/MetricsData.js